/* ============================================================
   Modulo: Lookbook Rail

   The rail scrolls natively — this wires the arrows, the progress
   thumb, and the hotspot cards.

   Encoded lessons, do not "simplify" them:
   - scrollBy's `left` is a PHYSICAL delta. A spec-compliant RTL scroller runs
     0 -> -max, so an unflipped Next is a silent no-op there while the
     disabled-state sync (which uses Math.abs) still looks correct.
   - The card's open/closed state is an ATTRIBUTE, never a style write. CSS owns
     the animation; JS owns the state. That keeps the reduced-motion rule in one
     place instead of duplicating it here.
   ============================================================ */
(function () {
  'use strict';
  if (typeof window === 'undefined') return;

  var REDUCE = window.matchMedia
    ? window.matchMedia('(prefers-reduced-motion: reduce)')
    : { matches: false };

  function closeSpot(spot) {
    spot.setAttribute('aria-expanded', 'false');
    var pop = spot.nextElementSibling;
    if (pop) pop.setAttribute('data-open', 'false');
  }

  function closeAll(root, except) {
    var open = root.querySelectorAll('.modulo-lbr__spot[aria-expanded="true"]');
    for (var i = 0; i < open.length; i++) {
      if (open[i] !== except) closeSpot(open[i]);
    }
  }

  function init(root) {
    if (!root || root.dataset.moduloLbrReady === '1') return;
    root.dataset.moduloLbrReady = '1';

    var rail = root.querySelector('[data-modulo-lbr-rail]');
    if (!rail) return;
    var prev = root.querySelector('[data-modulo-lbr-prev]');
    var next = root.querySelector('[data-modulo-lbr-next]');
    var thumb = root.querySelector('[data-modulo-lbr-thumb]');

    function sync() {
      var max = rail.scrollWidth - rail.clientWidth;
      // Math.abs: a spec-compliant RTL scroller runs 0 -> -max, so probe the
      // magnitude rather than sniffing the direction.
      var pos = Math.abs(rail.scrollLeft);
      if (prev) prev.disabled = pos <= 2;
      if (next) next.disabled = pos >= max - 2;
      if (thumb) {
        var frac = rail.scrollWidth > 0 ? rail.clientWidth / rail.scrollWidth : 1;
        var p = max > 0 ? pos / max : 0;
        thumb.style.width = (frac * 100).toFixed(2) + '%';
        thumb.style.insetInlineStart = (p * (1 - frac) * 100).toFixed(2) + '%';
      }
    }

    function page(dir) {
      var scene = rail.querySelector('.modulo-lbr__scene');
      if (!scene) return;
      var gap = parseFloat(window.getComputedStyle(rail).columnGap) || 0;
      var step = scene.getBoundingClientRect().width + gap;
      var rtl = window.getComputedStyle(rail).direction === 'rtl';
      rail.scrollBy({
        left: (rtl ? -1 : 1) * dir * step,
        // live query — the `behavior` option is consulted first and only 'auto'
        // defers to the CSS scroll-behavior
        behavior: REDUCE.matches ? 'auto' : 'smooth'
      });
    }

    if (prev) prev.addEventListener('click', function () { page(-1); });
    if (next) next.addEventListener('click', function () { page(1); });

    var raf = null;
    rail.addEventListener('scroll', function () {
      if (raf) window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(sync);
      // a card anchored to a dot would drift away from its dot while the rail
      // moves under it, so scrolling dismisses it
      closeAll(root);
    });

    // one delegated listener rather than a handler per dot
    root.addEventListener('click', function (e) {
      var spot = e.target.closest ? e.target.closest('.modulo-lbr__spot') : null;
      closeAll(root, spot);
      if (!spot) return;
      e.preventDefault();
      var isOpen = spot.getAttribute('aria-expanded') === 'true';
      spot.setAttribute('aria-expanded', String(!isOpen));
      var pop = spot.nextElementSibling;
      if (pop) pop.setAttribute('data-open', String(!isOpen));
    });

    root._moduloLbrSync = sync;
    root._moduloLbrClose = function () { closeAll(root); };
    sync();
  }

  function boot(scope) {
    var els = (scope || document).querySelectorAll('[data-modulo-lbr]');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // An identical <script src> still executes once per tag, so document- and
  // window-level listeners are wired exactly once.
  if (!window.moduloLbrWired) {
    window.moduloLbrWired = true;

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      var open = document.querySelectorAll('.modulo-lbr__spot[aria-expanded="true"]');
      for (var i = 0; i < open.length; i++) {
        closeSpot(open[i]);
        open[i].focus();
      }
    });

    // click anywhere outside a rail closes its cards
    document.addEventListener('click', function (e) {
      var roots = document.querySelectorAll('[data-modulo-lbr]');
      for (var i = 0; i < roots.length; i++) {
        if (roots[i].contains(e.target)) continue;
        if (roots[i]._moduloLbrClose) roots[i]._moduloLbrClose();
      }
    });

    var rt = null;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () {
        var roots = document.querySelectorAll('[data-modulo-lbr]');
        for (var i = 0; i < roots.length; i++) {
          if (roots[i]._moduloLbrSync) roots[i]._moduloLbrSync();
        }
      }, 150);
    });

    document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  }
})();
